import styled from '@emotion/styled'
import { MediaQuery } from '@pharmac-extranet/shared'
import { PharmacButtonBase } from '@pharmac/ui'
import { __EXTRANET_WRAPPER_WIDTH_PIXELS } from '../../constants'

export const ExtranetFiltersWrapper = styled.div`
  position: relative;
  width: 210px;

  @media (max-width: ${__EXTRANET_WRAPPER_WIDTH_PIXELS}px) {
    width: 100%;
  }
`

export const ExtranetFiltersButton = styled(PharmacButtonBase)<{ isOpen?: boolean }>`
  max-width: 180px;

  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  z-index: ${({ isOpen }) => (isOpen ? 10 : 0)};
  top: 0;
  left: 0;

  font-size: 16px;

  cursor: pointer;

  padding: var(--button-small-padding);

  background-color: ${(p) =>
    p.isOpen ? 'var(--tabs-list-item-selected-background)' : 'var(--color-white)'};

  border-radius: ${(props) => (props.isOpen ? '22px 22px 0 0' : '22px')};
  border-left: var(--button-secondary-border-left);
  border-top: var(--button-secondary-border-top);
  border-bottom: ${({ isOpen }) => (isOpen ? 'none' : 'var(--button-secondary-border-bottom)')};
  border-right: var(--button-secondary-border-right);

  &:hover {
    background-color: ${(p) =>
      p.isOpen ? 'var(--tabs-list-item-selected-background)' : 'var(--color-primary)'}!important;
    div {
      color: ${(p) => (p.isOpen ? 'var(--color-primary)' : 'white')};
    }
  }

  ${MediaQuery.maxTablet} {
    border: none;
    padding-left: var(--spacing-medium);

    .enfilters__button--icon {
      svg {
        width: 30px;
        height: 30px;
      }
    }

    .enfilters__button--text {
      display: none;
    }

    .enfilters__button--active-badge {
      position: absolute;
      top: 0px;
      right: 10px;
      height: 20px;
      width: 20px;
      font-size: 10px;
      border-radius: 50%;
      background-color: var(--color-purple);
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
    }
  }
`

export const ExtranetFiltersResetButton = styled.button`
  position: absolute;
  right: var(--spacing-tiny);
  top: 5px;

  ${MediaQuery.maxTablet} {
    top: 10px;
    left: 60px;
    width: 22px;
    height: 22px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  width: 28px;
  height: 28px;

  border-radius: 50%;
  border: 2px solid var(--color-accent-5);

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: var(--color-danger) !important;
    border-color: var(--color-danger);

    svg {
      color: white !important;
    }
  }

  svg {
    color: var(--color-accent-5);
  }
`

const containerStyles = ({ isOpen }: { isOpen?: boolean }) => ({
  maxHeight: isOpen ? '1000px' : '0px',
  padding: isOpen ? 'var(--spacing-large)' : '0',
  boxShadow: isOpen ? 'var(--box-shadow-medium)' : '0',
  border: isOpen ? 'var(--button-secondary-border-bottom)' : 0,
})

type ExtranetFiltersContainerProps = {
  isOpen?: boolean
  domRect?: DOMRect
}

export const ExtranetFiltersContainer = styled.div<ExtranetFiltersContainerProps>`
  position: absolute;
  z-index: 5;
  top: 35px;
  right: -10px;

  border-radius: var(--border-radius-tiny);

  width: calc(var(--extranet-wrapper-width) + 20px);
  background: var(--tabs-list-item-selected-background);

  ${containerStyles}

  overflow: ${(props) => (props.isOpen ? 'visible' : 'hidden')};

  @media (max-width: ${__EXTRANET_WRAPPER_WIDTH_PIXELS}px) {
    position: absolute;
    width: 100vw;

    ${MediaQuery.maxTablet} {
      left: -380px;
    }

    @media (max-width: 500px) {
      left: -280px;
    }

    @media (min-width: 430px) {
      left: -380px;
    }
  }
`

export const ExtranetFiltersButtonIcon = styled.div`
  margin-right: var(--spacing-small);

  svg {
    transform: translateY(2px);
  }
`

export const ExtranetFiltersContainerInner = styled.div`
  display: flex;
  flex-direction: column;
`
export const ExtranetFiltersRow = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;

  @media (max-width: ${__EXTRANET_WRAPPER_WIDTH_PIXELS}px) {
    flex-direction: column;
  }
`

export const ExtranetFiltersColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;

  padding: var(--spacing-medium);

  width: 25%;

  @media (max-width: ${__EXTRANET_WRAPPER_WIDTH_PIXELS}px) {
    width: 100%;
  }
`

export const ExtranetFiltersFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`
